import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import SecretariaService from '../../../../../../services/secretaria-auth';
import { Link, useParams, Navigate } from 'react-router-dom';


const Secretaria = () => {
    let { id } = useParams()

    const [nome, setNome] = useState("");
    const [endereco, setEndereco] = useState("");
    const [horarios, setHorarios] = useState("");
    const [telefone, setTelefone] = useState("");
    const [secretario, setSecretario] = useState("");
    const [competencias, setCompetencias] = useState("");
    const [sigla, setSigla] = useState("");
    const [email, setEmail] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchSecretaria(id) {
        const response = await SecretariaService.secEdit(id);
        setNome(response.data["nome"]);
        setEndereco(response.data["endereco"]);
        setHorarios(response.data["horarios"]);
        setTelefone(response.data["telefone"]);
        setSecretario(response.data["secretario"]);
        setCompetencias(response.data["competencias"]);
        setEmail(response.data["email"]);
        setSigla(response.data["sigla"]);
    }

    useEffect(() => {
        fetchSecretaria(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const local = await SecretariaService.editar(id, {
                nome: nome,
                endereco: endereco,
                horarios: horarios,
                telefone: telefone,
                secretario: secretario,
                competencias: competencias,
                sigla: sigla,
                email: email
            })
            if (local.data["_id"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="endereco">
                                <FloatingLabel
                                    label="Endereço"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="endereco"
                                        value={endereco}
                                        onChange={e => setEndereco(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="horarios">
                                <FloatingLabel
                                    label="Horários de Funcionamento"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="horarios"
                                        value={horarios}
                                        onChange={e => setHorarios(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Telefone de Atendimento (2554-XXXX)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="telefone"
                                        value={telefone}
                                        onChange={e => setTelefone(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="secretario">
                                <FloatingLabel
                                    label="Secretário(a)"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="secretario"
                                        value={secretario}
                                        onChange={e => setSecretario(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="sigla">
                                <FloatingLabel
                                    label="Sigla"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="sigla"
                                        value={sigla}
                                        onChange={e => setSigla(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="email">
                                <FloatingLabel
                                    label="E-mail"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="telefone">
                                <FloatingLabel
                                    label="Competências"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="competencias"
                                        value={competencias}
                                        onChange={e => setCompetencias(e.target.value)} as="textarea"
                                        rows={20} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/institucional/secretaria/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Secretaria editada com sucesso!</Alert>
                <Navigate to={'/restrito/institucional/secretaria/listar'} />
            </Fragment>
        )
    }
}

export default Secretaria;